/* eslint no-console:1 */

import axios from 'axios';

const addedClass = 'is-added';
const errorClass = 'is-error';
const delay = 1000;
const openTime = 3000;

export default class Cart {

  constructor(el) {

    this.el = el;
    this.hintBox = document.getElementById('add-to-cart-hint');
    this.errorWrapper = this.hintBox.querySelector('.error-wrapper p');
    this.buttonWrapper = document.querySelector('.meta-nav .button-cart');
    this.titleWrapper = this.hintBox.querySelector('.product-title');
    this.typeWrapper = this.hintBox.querySelector('.product-type');
    this.cartIndicatorArr = [].slice.call(document.querySelectorAll('.cart-indicator'));
    this.title = this.el.querySelector('input[name="title"]').value;
    this.type = this.el.querySelector('input[name="displayType"]').value;
    this.timer = null;
    this.time = openTime;
    this.inProgress = false;
    this.itemNumber = this.el.querySelector('input[name="id"]').value;
    this.isRental = this.el.action.indexOf('rental') > -1;

    this.el.addEventListener('submit', this.onSubmit.bind(this), false);
    this.el.querySelector('button').disabled = false;
  }

  onSubmit(e) {

    e.preventDefault();

    if (this.inProgress) {

      return;
    }

    this.inProgress = true;
    this.closeAlertBox();

    axios({
      withCredentials: true,
      method: 'POST',
      url: `${window.swinger.config.apiBase}/cart/item`,
      data: {'itemNumber':this.itemNumber,'isRental':this.isRental},
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-Referrer': document.location.href
      }
    })
    .then(res => {

      this.titleWrapper.innerHTML = this.title;
      this.typeWrapper.innerHTML = this.type;

      this.inProgress = false;
      this.buttonWrapper.classList.add('cart-has-items');
      this.cartIndicatorArr.forEach(elem => {

        elem.textContent = res.data.cartItemCount;
      });

      this.hintBox.classList.add(addedClass);
      this.closeAfterMs(openTime);
    })
    .catch(error => {

      this.inProgress = false;
      this.errorWrapper.textContent = error.response.data.errmsg || 'An error occurred';
      this.hintBox.classList.add(errorClass);
      this.closeAfterMs(openTime * 2);
    });
  }

  closeAfterMs(closeDelay) {
    if (this.timer) {

      window.clearInterval(this.timer);
      this.timer = null;
    }

    this.time = closeDelay;

    this.timer = window.setInterval(() => {

      this.time -= delay;
      if (this.time < 1) {

        this.closeAlertBox();
      }
    }, delay);
  }

  closeAlertBox() {

    if (this.timer) {

      window.clearInterval(this.timer);
      this.timer = null;
    }
    this.hintBox.classList.remove(addedClass);
    this.hintBox.classList.remove(errorClass);
  }
}
